@if (visible()) {
  <div
    aria-atomic="true"
    aria-label="Assessment Time"
    aria-live="off"
    class="hx-assessment-timer"
    role="timer"
    [attr.data-error]="error()"
    [attr.data-status]="status()"
    [attr.data-testid]="testId()"
    [class]="className()"
    [class.hx-assessment-timer--horizontal]="layout() === 'horizontal'">
    <div class="hx-assessment-timer__content">
      <span class="hx-assessment-timer__label">Assessment Time</span>
      <div
        class="hx-assessment-timer__time"
        [attr.aria-label]="displayTime()">
        {{ displayTime() }}
      </div>
    </div>
  </div>
}
